import { inject, Injectable } from '@angular/core';
import { SchemaBuilder } from '@spartacus/storefront';
import { Observable, of } from 'rxjs';
import { PageType, ProductSearchService, RoutingService, WindowRef } from '@spartacus/core';
import { filter, map, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ItemListSchemaBuilder implements SchemaBuilder {
  private router = inject(Router);

  constructor(
    private winRef: WindowRef,
    private routingService: RoutingService,
    private productSearchService: ProductSearchService
  ) {}

  build(): Observable<{}> {
    return this.routingService.getPageContext().pipe(
      map((context) => context.type),
      switchMap((type) => {
        if (type === PageType.PRODUCT_PAGE) {
          return of({}); // skip ItemList schema on PDP
        }
        return this.productSearchService.getResults().pipe(
          filter((results) => !!results && !!results.products?.length),
          map((results) => this.collect(results.products))
        );
      })
    );
  }

  protected collect(products: any): any {
    const baseUrl = this.winRef.location.origin;

    return {
      '@context': 'http://schema.org',
      '@type': 'ItemList',
      url: `${baseUrl}${this.router.url}`,
      numberOfItems: products?.length,
      itemListElement: products?.map((p, index) => {
        const productItem: any = {
          '@type': 'ListItem',
          position: index + 1,
          item: {
            '@type': 'Product',
            name: p?.name,
            image: p?.images?.PRIMARY?.zoom?.url || p?.images?.PRIMARY?.thumbnail?.url,
            url: `${baseUrl}${p?.url}`,
          },
        };

        if (p?.price?.value != null) {
          productItem.item.offers = {
            '@type': 'Offer',
            price: p.price.value,
            priceCurrency: p.price.currencyIso,
          };
        }

        return productItem;
      }),
    };
  }
}
